// extracted by mini-css-extract-plugin
export var avatar = "_nr-3";
export var avatarContainer = "_nr-2";
export var avatarSpacer = "_nr-5";
export var avatarSpacerContainer = "_nr-4";
export var avatarStackContainer = "_nr-1";
export var bubble = "_nr-0";
export var remainderBubble = "_nr-6";